import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";

import { faEnvelope, faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faTwitter,
	faGithub,
	faLinkedin,
	faInstagram,
	faFacebook,
} from "@fortawesome/free-brands-svg-icons";

import Logo from "../components/common/logo";

import INFO from "../data/user";
import SEO from "../data/seo";

import "./styles/homepage.css";

const Homepage = () => {
	const originalLogoSize = 100;
	const [stayLogo, setStayLogo] = useState(false);
	const [logoSize, setLogoSize] = useState(originalLogoSize);
	const [oldLogoSize, setOldLogoSize] = useState(originalLogoSize);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	useEffect(() => {
		const handleScroll = () => {
			let scroll = Math.round(window.scrollY, 2);

			let newLogoSize = originalLogoSize - (scroll * 4) / 10;

			if (newLogoSize < oldLogoSize) {
				if (newLogoSize > 40) {
					setLogoSize(newLogoSize);
					setOldLogoSize(newLogoSize);
					setStayLogo(false);
				} else {
					setStayLogo(true);
				}
			} else {
				setLogoSize(newLogoSize);
				setStayLogo(false);
			}
		};

		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, [logoSize, oldLogoSize]);

	const currentSEO = SEO.find((item) => item.page === "home");

	const logoStyle = {
		display: "flex",
		position: stayLogo ? "fixed" : "relative",
		top: stayLogo ? "3vh" : "auto",
		zIndex: 999,
		border: stayLogo ? "1px solid white" : "none",
		borderRadius: stayLogo ? "50%" : "none",
		boxShadow: stayLogo ? "0px 4px 10px rgba(0, 0, 0, 0.25)" : "none",
	};

	return (
		<React.Fragment>
			<Helmet>
				<title>{INFO.main.title}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div style={{ paddingTop: "130px" }}>
				<Logo style={logoStyle} width={logoSize} link={false} />
			</div>

			<div className="homepage-container">
				<div className="homepage-first-area">
					<div className="homepage-first-area-left-side">
						<div className="title homepage-title">
							<h6>Hey there, I'm</h6>
							<h1>{INFO.homepage.title}</h1>
							<h5>{INFO.homepage.summary}</h5>
						</div>
						<div className="subtitle homepage-subtitle">
							<p>{INFO.homepage.description}</p>
						</div>
						<div className="homepage-quote">
							<h2>
								{INFO.homepage.quote.split('"')[0]}
								<span>
									<em>
										{' "' +
											INFO.homepage.quote.split('"')[1] +
											'" '}
									</em>
								</span>
								{INFO.homepage.quote.split('"')[2]}
							</h2>
						</div>
					</div>
				</div>

				<div>
					<button
						className="homepage-download-resume"
						onClick={(e) => {
							window.open(INFO.homepage.resume_download_link);
						}}
					>
						Download Resume
					</button>
					<a
						href={INFO.homepage.resume_view_link}
						target="_blank"
						rel="noreferrer"
					>
						<FontAwesomeIcon
							icon={faEye}
							className="homepage-view-resume"
						/>
					</a>
				</div>

				<div className="homepage-socials">
					<a
						href={INFO.socials.twitter}
						target="_blank"
						rel="noreferrer"
					>
						<FontAwesomeIcon
							icon={faTwitter}
							className="homepage-social-icon"
						/>
					</a>
					<a
						href={INFO.socials.github}
						target="_blank"
						rel="noreferrer"
					>
						<FontAwesomeIcon
							icon={faGithub}
							className="homepage-social-icon"
						/>
					</a>
					<a
						href={INFO.socials.linkedin}
						target="_blank"
						rel="noreferrer"
					>
						<FontAwesomeIcon
							icon={faLinkedin}
							className="homepage-social-icon"
						/>
					</a>
					<a
						href={INFO.socials.instagram}
						target="_blank"
						rel="noreferrer"
					>
						<FontAwesomeIcon
							icon={faInstagram}
							className="homepage-social-icon"
						/>
					</a>
					<a
						href={INFO.socials.facebook}
						target="_blank"
						rel="noreferrer"
					>
						<FontAwesomeIcon
							icon={faFacebook}
							className="homepage-social-icon"
						/>
					</a>
					<a
						href={`mailto:${INFO.main.email}`}
						target="_blank"
						rel="noreferrer"
					>
						<FontAwesomeIcon
							icon={faEnvelope}
							className="homepage-social-icon"
						/>
					</a>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Homepage;
